export const settings = state => state.globalSettings;
export const settingsLoadInProgress = state => state.globalSettings === null;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/global-settings.js